import React, { Component } from 'react';
import {Spinner} from 'react-bootstrap';
import {InventoryUserMappedAction} from '../Dashboard/UserActions';
import DynamicTable from './dynamicTable';
import {GenerateTable, closeModalPopUp} from './dynamicTableActions';
import { connect } from 'react-redux';
import ShowModalPopUp from '../ShowModalPopUp';


class DynamicTableindex extends Component {
  componentDidMount(){    
    this.props.actioninventoryUserMapped()
  }
  render(){
    let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
    } 
    
    return(<div  className={(style) ? 'user' : "userSmall"}>
     {(this.props.showerror === true) ? (<ShowModalPopUp message={this.props.errmessage} falseShowModalPopUp={this.props.closeModalPopUp}/>) : null} 
      {this.props.isPending ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>Loading...</p> : null}
    <DynamicTable inventory={this.props.inventoryMapped} action={this.props} />    
  </div>)   
  }
}
function mapStateToProps(state){
  return{
    size: state.UserReducer.large,    
    loginAction: state.LoginReducer.loginAction, 
    inventoryMapped: state.UserReducer.inventoryMapped, 
    showerror:  state.dynamicTableReducer.showerror, 
    errmessage:  state.dynamicTableReducer.errmessage,
    isPending : state.dynamicTableReducer.isPendingCsat,
  }  
}

const mapDispatchToProps = (dispatch) => ({
  actioninventoryUserMapped:  () =>dispatch(InventoryUserMappedAction()),
  GenerateTable:  (a) =>dispatch(GenerateTable(a)),
  closeModalPopUp: () =>dispatch(closeModalPopUp())
})

export default connect(mapStateToProps, mapDispatchToProps)(DynamicTableindex);
